/** Channels */
export const FLETCHERS_CHANNEL = 'fletchers_channel';

/** Custom events */
export const BROADCAST_EXTRACT_PAGES_FROM_FULL_BUNDLE = 'broadcastExtractPagesFromFullBundle';
export const BROADCAST_REMOVE_PAGES_FROM_LIGHT_BUNDLE = 'broadcastRemovePagesFromLightBundle';
export const BROADCAST_SCROLL_TO_PAGE_ID_IN_FULL_BUNDLE = 'broadcastScrollToPageIdInFullBundle';
export const BROADCAST_SCROLL_TO_PAGE_ID_IN_LIGHT_BUNDLE = 'broadcastScrollToPageIdInLightBundle';
export const BROADCAST_SCROLL_TO_PAGE_ID_IN_LIGHT_BUNDLE_WHEN_EXTRACTED_FROM_FULL_BUNDLE =
  'broadcastScrollToPageIdInLightBundleWhenExtractedFromFullBundle';
// Fired from the Bundle tab's chronology button popover when the user picks a
// specific entry to jump to. The Chronology tab listens and scrolls its list
// to the matching entry ID; if no such tab is open, the sender falls back to
// opening a new tab with the `chronologyEntryIdOnInit` query param instead.
export const BROADCAST_SCROLL_TO_CHRONOLOGY_ENTRY_ID = 'broadcastScrollToChronologyEntryId';
export const BROADCAST_FORCE_TIMELINE_REFRESH = 'broadcastForceTimelineRefresh';
export const BROADCAST_ADD_TO_CHRONOLOGY_AND_LIGHT_BUNDLE_REFRESH = 'broadcastAddToChronologyAndLightBundleRefresh';
// Fired from the Chronology tab when entries are deleted or undone/redone. The
// Bundle (Full/Light) tabs listen for it and refresh their own data so the
// "in chronology" thumbnail indicator stays in sync across tabs.
export const BROADCAST_CHRONOLOGY_CHANGED_BUNDLE_REFRESH = 'broadcastChronologyChangedBundleRefresh';
export const BROADCAST_FORCE_CASE_OVERVIEW_CARDS_REFRESH = 'broadcastForceCaseOverviewCardsRefresh';
export const BROADCAST_FORCE_CATEGORY_LIST_REFRESH = 'broadcastForceCategoryListRefresh';
export const BROADCAST_UNDO_REDO_BUNDLE = 'broadcastUndoRedoBundle';
// Fired from a Bundle tab after pages are redacted. The other Bundle (Full/Light)
// tabs of the same case refetch /bundle for the new page URLs, keeping their scroll.
export const BROADCAST_REDACT_PAGES_BUNDLE_REFRESH = 'broadcastRedactPagesBundleRefresh';
export const BROADCAST_GDPR_CHECK_STARTED_FROM_CASE = 'broadcastGdprCheckStartedFromCase';
// Fired, to every tab including the sender, when a case's status is about to change in a way that locks or unlocks
// endpoints (e.g. a clone of it has just started). Each tab on that case re-reads case/status a few times over the
// next 20 seconds, as the backend can take a moment to update it.
export const BROADCAST_FORCE_CASE_STATUS_REFRESH = 'broadcastForceCaseStatusRefresh';
